import React from 'react';
import { withData } from '../DataController';
import { withRemote } from '../Utils/Utils';
import { getStyle, richTextLineHeight } from '../Utils/styleConversion';
import { debounce } from 'throttle-debounce';
import { getTableStyles } from '../components/Shared/EditableUtils';
import { sidebysides, simpleInlineStyles } from '@threeskye/editor-component-slate';
import { Node as SlateNode, Path as SlatePath } from 'slate';
import { ReactEditor } from 'slate-react';
import { listsOnKeyDown, withLists, getListDepth, resolveListStyleByDepth } from '../FlowingPage/listsPlugin';
import { toastSuccess } from '../components/popups/Toast'
import { MenuItem } from 'react-contextmenu';
import Editor from './Editor';
import TableRowStyleMenuItem from '@threeskye/editor-component-slate/dist/engine/context/table/TableRowStyleMenuItem';
import TableColumnStyleMenuItem from '@threeskye/editor-component-slate/dist/engine/context/table/TableColumnStyleMenuItem';
import EditorSubMenu from '@threeskye/editor-component-slate/dist/engine/context/EditorSubMenu';
import { buildSlateExtensions } from '../FlowingPage/buildEditorAddins';

class EditableText extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			content: null,
			editorKey: 1,
			editorId: '_' + Math.random().toString(36).substr(2, 9),
			addins: [],
			editable: false,
			toolbar: props.config.customisedToolbarButtons
				? { type: "customised", buttons: props.config.customisedToolbarButtons }
				: { type: "full" },
			keepInsertOpen: false
		}


		this.onChange = debounce(300, this.onChange.bind(this));
		this.listener = this.listener.bind(this);

		this.tableStyles = getTableStyles(props.styles, props.config.rowStyleOptions, props.config.columnStyleOptions, props.data);

		this.tableStyleRef = React.createRef();

		this.rowStyles = props.config.rowStyleOptions && props.config.rowStyleOptions.map(option => <MenuItem onClick={() => this.tableStyleRef.current.setRowStyle(option.key)}>{option.label}</MenuItem>);

		this.setToolbar = this.setToolbar.bind(this);

		this.throwToaster = this.throwToaster.bind(this);

	}

	componentDidMount() {
		if (this.props.RawEditableText) {
			const typeofLoad = typeof this.props.load
			if (typeofLoad !== 'string') {
				const parsedLoad = JSON.stringify(this.props.load);
				this.listener(null, null, parsedLoad);
			} else this.listener(null, null, this.props.load);
			return
		};
		this.props.data.addLocalListener(this.listener);
		this.listener();
	}

	componentWillUnmount() {
		if (this.props.RawEditableText) return;
		this.props.data.removeLocalListener(this.listener);
	}

	setToolbar(toolbar) {
		this.setState({ toolbar: toolbar })
	}

	throwToaster() {
		toastSuccess('Link Copied')
	}

	listener(src, srcDataName, genericContent) {

		if (srcDataName && this.props.config.dataName !== srcDataName) {
			return new Promise((resolve) => resolve(false));

		}
		if (src && src === this.state.editorId) {
			return new Promise((resolve) => resolve(false));
		}
		this.setState({ editable: false })
		const config = this.props.config;
		const dataName = config.dataName + (this.props.dataSuffix ? this.props.dataSuffix : '');
		const content = this.props.RawEditableText ? genericContent : this.props.data.getLocalValue(dataName);
		const parsedContent = content ? JSON.parse(content) : null;

		if (content && content !== null && content !== "" && (this.props.data?.localContentLoaded || this.props.RawEditableText)) {
			//FIXME editor not handling updating props, so change whole component. BAD! fix in editor.
			//this.setState({ content, editorKey: this.state.editorKey + 1 });
			const formattedcontent = parsedContent && parsedContent.length > 0 ? content : [{ type: 'text', children: [{ text: '' }] }];
			this.setState({ content: formattedcontent, editorKey: this.state.editorKey + 1 });
		} else {
			this.setState({ content: null, editorKey: this.state.editorKey + 1 });
		}

		const { styles } = this.props;

		const myStyles = Object.keys(config.styles).map(key => {
			const actual = styles[config.styles[key]];
			if (!actual) return null
			const converted = this.props.data && this.props.data.getStyle ? this.props.data.getStyle(actual) : {};
			converted.lineHeight = this.props.lineHeight ? this.props.lineHeight : richTextLineHeight(actual, converted, "1.2");
			const val = {};
			val[key] = converted;
			return val;
		});
		const tableStyles = config.tableStyles;
		const defaultCellStyle = this.props.data && this.props.data.getStyle ? this.props.data.getStyle(styles[config.styles.cell], true) : {};
		const cellHeaderStyle = this.props.data && this.props.data.getStyle ? this.props.data.getStyle(styles[config.styles.cellHeader], true) : {};

		//browser default cellHeader is text-align: center... kill this
		if (cellHeaderStyle && !cellHeaderStyle.hasOwnProperty("textAlign")) {
			cellHeaderStyle.textAlign = "left";
		}

		const flattenedStyles = {};
		myStyles.forEach(style => Object.assign(flattenedStyles, style));

		const tdStyle = {};
		const thStyle = {};

		const paddingBelowTable = config.paddingBelowTable;
		if (paddingBelowTable) {
			flattenedStyles.table = {
				marginBottom: paddingBelowTable + "pt"
			}
		} else {
			flattenedStyles.table = {
				marginBottom: tableStyles.cellVerticalPadding + "pt"
			}
		}

		Object.assign(tdStyle, defaultCellStyle);
		flattenedStyles.td = tdStyle;
		Object.assign(thStyle, cellHeaderStyle);
		flattenedStyles.th = thStyle;

		if (tableStyles.tableBorder) {
			const borderStyle = this.props.data && this.props.data.getStyle ? this.props.data.getStyle(styles[tableStyles.tableBorder]) : {};
			flattenedStyles['table-table'] = borderStyle;
		}

		if (flattenedStyles["tableBorder"]) {
			flattenedStyles["table-border"] = {
				"border": `${flattenedStyles["tableBorder"].borderLeftWidth} ${flattenedStyles["tableBorder"].borderLeftStyle} ${flattenedStyles["tableBorder"].borderLeftColor}`
			};
		}

		const menuItems = [];
		if (config.rowStyleOptions) {
			menuItems.push(
				<EditorSubMenu title='Row styles'>
					{config.rowStyleOptions.map((option, idx) => <TableRowStyleMenuItem key={"rowStyleOptions" + idx} styleName={option.key} text={option.label} showPreview={true} />)}
				</EditorSubMenu>
			)
		}
		if (config.columnStyleOptions) {
			menuItems.push(
				<EditorSubMenu title='Column styles'>
					{config.columnStyleOptions.map((option, idx) => <TableColumnStyleMenuItem key={"columnStyleOptions" + idx} styleName={option.key} text={option.label} showPreview={true} />)}
				</EditorSubMenu>
			)
		}

		const tableOptions = {
			initialFooter: true,
			menuItems: menuItems,
			styleRef: this.tableStyleRef,
			styleInterpreter: style => {
				if (style === 'bordered-table') {
					return flattenedStyles["table-border"]
				}

				for (const { label, key } of config.rowStyleOptions) {
					if (style === key) {
						return this.tableStyles[key];
					}
				}
				for (const { label, key } of config.columnStyleOptions) {
					if (style === key) {
						return this.tableStyles[key];
					}
				}
				return null;
			},
			hoverOptions: ["border"] // TODO: Hover options should be configurable (from template/config)
		};

		const imageOptions = {
			menuItems: ["border"],
			styleInterpreter: style => {
				if (style === 'with-border') {
					return myStyles["image-border"]
				}
				return null;
			},
			contextMenu: {
				// this will break visually if not both true, 
				// TODO - update 3skye-slate to handle both horiz and vert, iconMenuItems and checkedMenuItems
				horizontal: true,
				iconButton: true
			},
			contextMenuOrder: [
				0,
				1,
				2,
				3,
				"divider",
				"border",
				"divider",
				"header",
				"footer",
				"divider",
				"createSBS",
				"breakSBS",
				"divider",
				"delete"
			]
		};

		const sbsOptions = {
			styleInterpreter: style => {
				if (style && style.includes("with-gap") && style.includes("with-border")) {
					return { ...myStyles["with-border"], gap: myStyles["sbsGap"] ? myStyles["sbsGap"].fontSize : 12 }

				} else if (style === "with-border") {
					return myStyles["with-border"]

				} else if (style === "with-gap") {
					return { gap: myStyles["sbsGap"] ? myStyles["sbsGap"].fontSize : 12 }
				}
			}
		}

		const sbs = sidebysides(tableOptions, imageOptions, sbsOptions);


		const headings = {
			install: editor => {
				return {
					getRenderer: (type, editor) => {
						if (type === "heading-one")
							return ({ attributes, children }) => <h1 {...attributes}>{children}</h1>
						else if (type === "heading-two")
							return ({ attributes, children }) => <h2 {...attributes}>{children}</h2>
						else if (type === "heading-three")
							return ({ attributes, children }) => <h3 {...attributes}>{children}</h3>
						else
							return null;
					},
					editor: editor

				}
			}
		}

		const lists = {
			install: editor => {
				withLists(editor);
				return {
					getRenderer: (type, editor) => {
						if (type === "list-item")
							return ({ attributes, children, element }) => {
								const path = ReactEditor.findPath(editor, element)
								const parentPath = SlatePath.parent(path);
								const grandpaPath = SlatePath.parent(parentPath);
								const grandpaNode = SlateNode.get(editor, grandpaPath)
								const isCellChild = grandpaNode && grandpaNode.type === 'table-cell'
								const liName = this.props.config && this.props.config.styles && this.props.config.styles.li;
								const liStyleObj = liName && this.props.styles && this.props.styles[liName];
								const liInlineStyle = liStyleObj && this.props.data && this.props.data.getStyle ? this.props.data.getStyle(liStyleObj) : null;
								const cellStyle = isCellChild ? { margin: 0, color: 'inherit', fontSize: 'inherit', fontWeight: 'inherit', lineHeight: 'inherit' } : null
								const style = cellStyle || liInlineStyle ? { ...liInlineStyle, ...cellStyle } : null

								const updatechildren = children.map((child) => {
									if (child.props.text && child.props.text.url !== undefined && child.props.text.url !== null) {
										const url = child.props.text.url
										const href = (url.includes('http://') || url.includes('https://')) ? url : 'http://' + url
										const colour = child.props.text.color
										const decoration = child.props.text.underline ? 'underline' : 'none'
										const text = child.props.text.text
										const linkStyles = { fontWeight: 600, cursor: 'pointer', color: colour || '#A9754E', textDecoration: decoration }
										return (
											<a target='_blank' href={href} style={linkStyles} onClick={(e) => this.setToolbar({ type: 'link-tooltip', text: text, href: href })} {...attributes}>
												{child}
											</a>
										)
									} else return child
								})
								return <li {...attributes} style={style} >{updatechildren}</li>
							}
						else if (type === "numbered-list")
							return ({ attributes, children, element }) => {
								const path = ReactEditor.findPath(editor, element)
								const parentPath = SlatePath.parent(path);
								const parentNode = SlateNode.get(editor, parentPath)
								const isCellChild = parentNode && parentNode.type === 'table-cell'
								const cellStyle = isCellChild ? { margin: 0, color: 'inherit', fontSize: 'inherit', fontWeight: 'inherit', lineHeight: 'inherit' } : null
								const depthStyle = resolveListStyleByDepth(getListDepth(editor, path), 'numbered-list', { config: this.props.config, styles: this.props.styles, data: this.props.data });
								const style = cellStyle || depthStyle ? { ...cellStyle, ...depthStyle } : null;
								return <ol {...attributes} style={style}>{children}</ol>
							}
						else if (type === "bulleted-list")
							return ({ attributes, children, element }) => {
								const path = ReactEditor.findPath(editor, element)
								const parentPath = SlatePath.parent(path);
								const parentNode = SlateNode.get(editor, parentPath)
								const isCellChild = parentNode && parentNode.type === 'table-cell'
								const cellStyle = isCellChild ? { margin: 0, color: 'inherit', fontSize: 'inherit', fontWeight: 'inherit', lineHeight: 'inherit' } : null
								const depthStyle = resolveListStyleByDepth(getListDepth(editor, path), 'bulleted-list', { config: this.props.config, styles: this.props.styles, data: this.props.data });
								const style = cellStyle || depthStyle ? { ...cellStyle, ...depthStyle } : null;
								return <ul {...attributes} style={style}>{children}</ul>
							}
						else
							return null;
					},
					onKeyDown: (event) => {
						listsOnKeyDown(editor, event);
					},
					editor: editor
				}
			}
		}

		// additionalAddins: extra editor addins injected by read-only hosts (e.g. the
		// compare view's diff-marks addin) — same {install} shape as the built-ins.
		this.setState({ addins: simpleInlineStyles().concat([sbs, headings, lists]).concat(this.props.additionalAddins || []), flattenedStyles, editable: true });
		return new Promise((resolve) => resolve(true));

	}

	onChange(data, overflown, initial) {
		if (initial)
			return;
		if (this.props.RawEditableText) {
			// Raw mode has no data controller — withRawComponent substitutes
			// data={{ getStyle }}, so updateLocalData never exists here. Hosts that
			// persist (DynamicDetails) pass onChange; read-only hosts (compare
			// panes) pass none, and a normalisation onChange must be a no-op.
			if (this.props.onChange)
				this.props.onChange(data);
			return;
		}
		const dataName = this.props.config.dataName + (this.props.dataSuffix ? this.props.dataSuffix : '');
		this.props.data.updateLocalData(dataName, JSON.stringify(data), this.state.editorId, this.props.config.dataName);
	}


	render() {
		const config = this.props.config;
		const styles = this.props.styles;
		const foundStyle = styles["brand-colour-one"] || styles["company-header"] || styles["page-header"] || styles["logo"] || null
		const colour1 = foundStyle && foundStyle.color ? foundStyle.color : null
		const colourOptions = colour1 ? [colour1, '#2536f0'] : ['#2536f0']
		const builtExtensions = buildSlateExtensions({
			extensionsConfig: config.extensions,
			// Page.js bakes JSX into state at construct time, so direct values
			// would be frozen at mount. Pass the getters it provides so click
			// handlers read live portfolios from the BuilderPage instance.
			getPortfoliosState: this.props.getPortfoliosState,
			getPortfoliosGroupedState: this.props.getPortfoliosGroupedState,
			getCurrentFundNumber: this.props.getCurrentFundNumber,
			getPasteGroupings: this.props.getPasteGroupings,
			getAllFunds: this.props.getAllFunds,
			pasteGroupName: config.pasteGroup,
			remote: this.props.remote,
			getContent: () => {
				// Read fresh from the data layer: the local listener short-circuits
				// when src === this.state.editorId, so this.state.content is not
				// refreshed for self-edits — capturing it would yield load-time
				// content for the active editor.
				const dataKey = config.dataName + (this.props.dataSuffix ? this.props.dataSuffix : '');
				const raw = this.props.data && this.props.data.getLocalValue(dataKey);
				return raw ? JSON.parse(raw) : null;
			},
			templateName: this.props.data && this.props.data.templateName,
			dataName: config.dataName,
			keepInsertOpen: this.state.keepInsertOpen,
			setKeepInsertOpen: (boolean) => this.setState({ keepInsertOpen: boolean }),
		});
		const extensions = config.hideInsertMenu
			? null
			: (Object.keys(builtExtensions).length > 0 ? builtExtensions : this.props.extensions)
		const customisedToolbarButtons = config.customisedToolbarButtons ? { type: "customised", buttons: config.customisedToolbarButtons } : null
			? {
				...this.props.extensions, insertTable: {
					show: true,
					keepInsertOpen: this.state.keepInsertOpen,
					setKeepInsertOpen: (boolean) => {
						this.setState({ keepInsertOpen: boolean })
					}
				}
			}
			: {
				insertTable: {
					show: true,
					keepInsertOpen: this.state.keepInsertOpen,
					setKeepInsertOpen: (boolean) => {
						this.setState({ keepInsertOpen: boolean })
					}
				}
			};
		const options = {
			disableSideBySide: config.disableSideBySide
		};

		if (config.rowStyleOptions) {
			options.rowStyleOptions = config.rowStyleOptions;

		}
		if (config.columnStyleOptions) {
			options.columnStyleOptions = config.columnStyleOptions;
		}

		let flattenedStyles = this.state.flattenedStyles;
		//TODO style options
		//Object.assign(flattenedStyles, this.tableStyles);
		// Anchor the insert menu to the top-left of the field instead of the
		// viewport. The library spreads `insertMenuPosition` after its hardcoded
		// { position: 'fixed', top: '50%', bottom: '50%' } so these keys override.
		const defaultInsertMenuPosition = {
			position: 'absolute',
			top: 0,
			bottom: 'auto',
			left: '-32pt',
		};
		return <Editor
			key={this.state.editorKey}
			readOnly={this.props.RawEditableText ? !this.props.editable : !this.state.editable || !this.props.data.localContentLoaded}
			options={options}
			load={this.state.content}
			width={config.width}
			height={config.height}
			styles={styles}
			myStyles={flattenedStyles || {}}
			onChange={this.onChange}
			addins={this.state.addins}
			toolbar={this.state.toolbar}
			setToolbar={this.setToolbar}
			colourOptions={colourOptions}
			hideToc
			throwToaster={this.throwToaster}
			noEditStates={this.props.noEditStates}
			renderFlowtingInsertMenu={extensions && Object.keys(extensions).length > 0}
			extensions={extensions}
			customisedToolbarButtons={customisedToolbarButtons}
			passedOnDrop
			insertMenuPosition={this.props.insertMenuPosition || defaultInsertMenuPosition}
			keepInsertOpen={this.state.keepInsertOpen}
			passedClassName={this.props.passedClassName}
			passedId={this.props.passedId}
			editableStyle={this.props.editableStyle}
		/>
	}
}

export default withData(withRemote(EditableText));

const withRawComponent = (Component) => {
	return (props) => {

		// Shared conversion (Utils/styleConversion.js) — keeps the Raw/compare path
		// identical to the editor's DataController.getStyle (option 1B).

		function getTop(id) {
			const el = document.getElementById(id);
			if (!el) return null;
			const top = el.getBoundingClientRect().top;
			const height = el.getBoundingClientRect().height;
			return top + (height / 2);
		}

		function getLeft(id) {
			const el = document.getElementById(id);
			if (!el) return null;
			const left = el.getBoundingClientRect().left;
			return left - 50;
		}

		return <Component RawEditableText {...props} data={{ getStyle }} insertMenuPosition={{ left: getLeft("raw-slate-detail-editor"), top: getTop("raw-slate-detail-editor") }} />
	}
}
export const RawEditableText = withRawComponent(EditableText);